import { Component } from '@angular/core';

@Component({
  selector: 'app-add-order',
  standalone: true,
  imports: [],
  templateUrl: './add-order.component.html',
  styleUrl: './add-order.component.css',
})
export class AddOrderComponent {}
